<template>
  <div class="content-item flex align-items-center">
    <div class="content-item-label">
      <span v-if="JSON.parse(commonData[1].value) === '1'" class="red">*</span
      >{{ JSON.parse(commonData[2].value) }}
    </div>
    <div class="keyword-list">
      <el-tag
        class="eltag"
        size="mini"
        :key="item"
        v-for="item in aliasName"
        closable
        :disable-transitions="false"
        style="margin-left: 10px"
        @close="closeTag(item)"
        >{{ item }}
      </el-tag>
      <el-input
        class="input-keyword"
        ref="saveTagInput"
        show-word-limit
        :maxlength="Number(JSON.parse(this.commonData[0].value))"
        v-model="input"
        @keyup.enter.native="getKeyword"
        placeholder="输入别名后，回车确定；别名可输入多个"
      ></el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: "aliasName",
  props: ["aliasName", "commonData"],
  data() {
    return {
      input: "",
      keywordInfos: this.aliasName,
      infolength: 0, //别名输入框数组总和
    };
  },
  created() {},
  methods: {
    closeTag(item) {
      this.keywordInfos.splice(this.keywordInfos.indexOf(item), 1);
      this.aliasName.map((item1) => {
        //删除处理
        if (item1 == item) {
          this.aliasName.splice(this.aliasName.indexOf(item1), 1);
        }
      });
    },
    getKeyword() {
      this.input = this.input.replace(/@/g, "");
      if (this.aliasName) {
        if (
          this.aliasName.length >
          Number(JSON.parse(this.commonData[0].value)) - 1
        ) {
          this.$message.error("别名最多存在20个");
          return;
        }
        let isPush = this.aliasName.some((item) => item == this.input); //检测别名有没有重复
        if (!isPush) {
          this.aliasName && this.aliasName.push(this.input);
        }
      } else {
        this.aliasName = [];
        this.aliasName.push(this.input);
      }
      this.input = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.keyword-list {
  width: 521px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .el-tag {
    margin-top: 5px;
    background-color: #f4f4f5;
    border-color: #e9e9eb;
    color: #909399;

    .el-tag__close {
      color: #909399;

      &:hover {
        background-color: #f4f4f5;
      }
    }
  }
  .input-keyword {
    border: none;
    flex-shrink: 0;
    width: 519px !important;

    :deep(.el-input__inner) {
      border: none !important;
      line-height: 26px;
      height: 26px;
    }
  }
}
.content-item-label {
  span {
    color: #f62458;
    margin-right: 5px;
  }
}
</style>
